module.exports = __webpack_public_path__ + "static/media/sp.e7b25315.gif";